"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/icon/icon");
const avatar_styles_1 = require("@/components/common/avatar/avatar.styles");
const icon_names_1 = require("@/components/common/icon/icon-names");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let Avatar = class Avatar extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'primary';
        this.size = '40';
        this.shape = 'square';
        this.ariaLabel = '';
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderImage()} ${this.renderIcon()} ${this.renderFallback()}
    `;
    }
    updated(changedProperties) {
        if (!changedProperties.has('ariaLabel'))
            return;
        if (this.ariaLabel)
            this.setAttribute('role', 'img');
        else
            this.removeAttribute('role');
    }
    renderImage() {
        if (!this.src)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <img src=${this.src} alt="" />
    `;
    }
    renderIcon() {
        if (this.src || !this.icon)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-icon name=${this.icon} size=${this.iconSize} aria-hidden="true"></mm-icon>
    `;
    }
    renderFallback() {
        if (this.src || this.icon)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <slot>
        <mm-icon name=${icon_names_1.ICON_NAMES.PROFILE} size=${this.iconSize} aria-hidden="true"></mm-icon>
      </slot>
    `;
    }
    get iconSize() {
        return this.size === '48' || this.size === '80' ? 'large' : 'medium';
    }
};
Avatar.styles = [shared_styles_1.resetStyles, avatar_styles_1.avatarStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true, useDefault: true })
], Avatar.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true, useDefault: true })
], Avatar.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true, useDefault: true })
], Avatar.prototype, "shape", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Avatar.prototype, "src", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Avatar.prototype, "icon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], Avatar.prototype, "ariaLabel", void 0);
Avatar = __decorate([
    (0, decorators_js_1.customElement)('mm-avatar')
], Avatar);
exports.Avatar = Avatar;
//# sourceMappingURL=data:application/json;base64,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